import { LogicalDeleteDTO } from '../basic/logicalDeleteDTO';
import { TenantDTO } from '../domain/tenant';
import { CollaboratoreDTO } from '../domain/collaboratore';

export class MalattiaDTO extends LogicalDeleteDTO {
    id: number;
    tenant: TenantDTO;
    dataDa: Date;
    dataA: Date;
    collaboratore: CollaboratoreDTO;
    codice: string;
}